{
  "name": "micro-frontends",
  "version": "1.0.0",
  "repository": "git@github.com:Javiani/micro-frontends.git",
  "author": "Javiani <eduardo.ottaviani@gmail.com>",
  "license": "MIT",
  "host": "https://mfe-jails.netlify.app",
  "scripts": {
    "dev": "NODE_ENV=dev parcel src/mfes/**/page.pug --no-cache",
    "build": "rm -rf ./dist && parcel build src/shared/main.ts && parcel build src/mfes/**/*.{css,ts,pug} --no-content-hash --no-cache",
    "create:mfe": "node tasks/create"
  },
  "devDependencies": {
    "@parcel/transformer-pug": "^2.13.0",
    "parcel": "^2.13.0"
  },
  "dependencies": {
    "@rive-app/canvas": "^2.13.2",
    "jails-js": "^6.3.3",
    "jails.std": "^0.2.5",
    "swiper": "^11.2.6"
  }
}
